import config from "../../../../config";
import * as modules from "./modules/";
const { vendor } = config;

const ScrollToTop = modules[vendor] ? modules[vendor] : modules["default"];

export default ScrollToTop;
